<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Book Description</span></p>
<p class="P_WFP_BodyText">It’s just supposed to be an educational field trip to the Challenger Learning Center, but JJ Wren and her friends find themselves transported into the future, to a time when the human race is besieged by deadly alien invaders. The evil Kylarn have shifted the orbits of three asteroids, sending them on a collision course with Earth!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?4cdab26b